import { Heading, Link, Text } from '@primer/react';
import ComponentLayout from '~/src/layouts/component-layout';
import { AccessibilityLink } from '~/src/components/accessibility-link';
import { Link as GatsbyLink } from 'gatsby';
import * as React from 'react';
export default {
  Heading,
  Link,
  Text,
  ComponentLayout,
  AccessibilityLink,
  GatsbyLink,
  React
};